export default "https://0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/75fd16ef8fd9b62d186dee6a313917d9.jpg";